import LaunchIcon from '@mui/icons-material/Launch';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface UrlPreviewProps {
  url: string;
}

export function UrlPreview(props: UrlPreviewProps) {
  const { url } = props;

  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'grid',
        gap: '1rem',
        placeContent: 'center',
        placeItems: 'center',
        minHeight: '100%',
      }}
    >
      <Typography>{t('URL_PREVIEW.NO_PREVIEW_AVAILABLE')}</Typography>
      <Button
        variant="text"
        size="large"
        startIcon={<LaunchIcon />}
        href={url}
        target="_blank"
      >
        {t('URL_PREVIEW.OPEN_IN_NEW_WINDOW')}
      </Button>
    </Box>
  );
}
